import { EventEmitter } from 'events';
import { isFunction } from 'lodash-es';
import { Application } from './application';
import * as downloads from './downloads';

export interface ResourceProxyOptions {
  url: string | Function;
  useAuth?: boolean;
}

export class ResourceProxy {
  // readonly eventbus: Vue;
  readonly eventbus: EventEmitter;
  protected loading: boolean;

  url: string | Function;
  useAuth: boolean;

  constructor(app: Application, options: ResourceProxyOptions) {
    this.loading = false;
    this.eventbus = new EventEmitter();
    this.url = options.url;
    this.useAuth = options.useAuth || false;
  }

  getURL() {
    const url = isFunction(this.url) ? this.url() : this.url;
    return url ? downloads.normalizeLink(url) : null;
  }

  on(event: string, callback: (...args: any[]) => void) {
    this.eventbus.addListener(event, callback);
    return this;
  }

  async load() {
    if (this.loading) {
      return;
    }

    const url = this.getURL();
    if (url) {
      try {
        this.loading = true;
        const result = await downloads.getFileBLOB(url);
        this.eventbus.emit('file', result);
      } finally {
        this.loading = false;
      }
    }
  }
}
